import { ChartFacade } from '@mode/charts/contract';
import { CompiledField, Switch } from '@mode/shared/util-switch';
import { DomainLoader } from './colors-modal.component';
import { BatchEncoder, EMPTY_ENCODING } from '@mode-vegas/vegas';
import { FlamingoTypes } from '@mode/shared/contract-common';
import * as ColorModalHelpers from './colors-modal-helpers';
import { View } from '@mode-switch/model';
import { DataRole } from '@mode-switch/express';

export class FieldListDomainLoader implements DomainLoader {
  private dimensions: readonly View.Attr<DataRole>[];

  constructor(
    private view: FlamingoTypes.ModeView,
    private queryRunToken: string
  ) {
    const model = Switch.Models.make('model', [this.view]);
    this.dimensions = Switch.Attrs.dimensions(model, this.view.name);
  }

  fetchDomain(
    chartFacade: ChartFacade,
    currentField: CompiledField,
    onResult: (result: any[]) => void,
    onError: (error: string) => void
  ): void {
    // If a dimension, then fetch domain values.
    // If a measure, return an empty array since we don't display ranges.
    if (this.dimensions.find((attr) => attr.name === currentField.attrName)) {
      const encoder = new BatchEncoder({ ...EMPTY_ENCODING });
      const asEncField = { ...currentField.toEncField(), id: currentField.alias };
      encoder.addEncField(asEncField, 'column');
      const encoding = encoder.complete().encoding;
      const domain$ = ColorModalHelpers.fetchColorDomain(
        chartFacade,
        currentField,
        this.view,
        encoding,
        this.queryRunToken ?? '',
        'field-list',
        true
      );

      domain$.subscribe({
        next: (domain) => {
          onResult(domain);
        },
        error: (error) => {
          onError(`Unable to load field values: ${error.message}`);
        },
      });
    } else {
      onResult([]);
    }
  }
}
